<template>
  <el-form ref="form" :model="addInteboMachineApply" :rules="rules" label-width="80px" style="padding: 10px;" class="myfrom">
    <el-form-item label="申请人">
      <el-input v-model="addInteboMachineApply.applyusername" size="mini" disabled></el-input>
    </el-form-item>
    <el-form-item label="借用客户" prop="khs">
      <el-cascader size="mini" v-model="addInteboMachineApply.khs" ref="khs" style="width: 100%"
                             :options="inteboStoreSturct" class="cascader" :props="props" clearable @change="khsChange"></el-cascader>
    </el-form-item>
    <el-form-item label="收货人" prop="head">
      <el-input v-model="addInteboMachineApply.head" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="手机号码" prop="headphone">
      <el-input v-model="addInteboMachineApply.headphone" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="收货地址" prop="address">
      <el-input v-model="addInteboMachineApply.address" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="仪器型号" prop="goodssku">
      <el-select v-model="addInteboMachineApply.goodssku"  style="width: 100%" size="mini" @change="goodsskuChange">
        <el-option label="C100"  :value="1"></el-option>
        <el-option label="A100" :value="2"></el-option>
        <el-option label="A200" :value="3"></el-option>
        <el-option label="其他"  :value="4"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="数量" prop="number">
      <el-input v-model="addInteboMachineApply.number" type="number" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="借用日期" prop="fromdate">
      <el-date-picker size="mini" :editable="false" v-model="addInteboMachineApply.fromdate" style="width: 100%;" type="date" placeholder="开始日期" value-format="yyyy-MM-dd">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="归还日期" prop="todate">
      <el-date-picker size="mini" :editable="false" v-model="addInteboMachineApply.todate" style="width: 100%;" type="date" placeholder="开始日期" value-format="yyyy-MM-dd">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="借用理由" prop="remarks">
      <el-input type="textarea" size="mini" v-model="addInteboMachineApply.remarks"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" style="width:100%" @click="saveInteboMachineapply">借用申请</el-button>
    </el-form-item>
    </el-form>
</template>
<script>
export default {
    data() {
        return {
            props: {checkStrictly: true},
            inteboMachineApply: {
                khs: [],
                proceid: "",
                applyusername: "",
                applyuser: "",
                applyparentid: "",
                applystoreid: "",
                remarks: "",
                goodssku: "",
                goodsskuname: "",
                number: 1,
                fromdate: "",
                todate: "",
                createdate: "",
                examinedate: "",
                status: 1,
                head: "",
                headphone: "",
                address: "",
            },
            addInteboMachineApply: {},
            inteboStoreSturct: [],
            rules: {
                khs: [
                    {required: true, message: "请选择客户信息", trigger: 'change'},
                ],
                goodssku: [
                    {required: true, message: "请选择仪器型号", trigger: 'change'},
                ],
                number: [
                    {required: true, message: "请填写数量", trigger: 'change'},
                ],
                fromdate: [
                    {required: true, message: "请选择借用日期", trigger: 'change'},
                ],
                todate: [
                    {required: true, message: "请选择归还日期", trigger: 'change'},
                ],
                remarks: [
                    {required: true, message: "请输入借用理由", trigger: 'change'},
                ],
                head: [
                    {required: true, message: "请输入收货人", trigger: 'change'},
                ],
                headphone: [
                    {required: true, type: "string", len: 11, message: "请输入手机号码", trigger: 'change'},
                ],
                address: [
                    {required: true, message: "请输入收货地址", trigger: 'change'},
                ]
            }
        };
    },
    created: function () {
        this.getInteboStoreSturct();
        this.addApply();
        /*let userId = this.$getUrlKey("userId");
    let code = this.$getUrlKey("code");
    if (userId || code) {
      if (userId) {
        this.getCorpUserInfo(userId);
      }
    } else {
        window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getInteboCorpCode?state="+encodeURIComponent("http://intebo.shmiaojie.cn/#/inteboMachineApply");
      //window.location.href="http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechat/getCorpidCode?state=7";
      //window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getThirdCorpidCode?state=11";
    }*/
        /*this.getInteboStoreSturct();
    this.addApply();*/
    },
    methods: {
        getCorpUserInfo(staffid) {
            this.$post("wechat/getInteboCorpUserInfo", {staffid: staffid}).then(res => {
                if (res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        //如果钉钉没找到就关闭页面
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("storeid", data.staff.storeid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        this.getInteboStoreSturct();
                        this.addApply();
                    }
                }
            });
        },
        khsChange(val) {
            this.$refs["khs"].dropDownVisible = false;
        },
        addApply() {
            this.addInteboMachineApply = this.$copy(this.inteboMachineApply);
            this.addInteboMachineApply.applyuser = localStorage.getItem("staffid");
            this.addInteboMachineApply.applyusername = localStorage.getItem("staffname");
            //this.addInteboMachineApply.applyuser="beb90776ee6b460fbdc08eda3577fb0c";
            //this.addInteboMachineApply.applyusername="周华龙";
            if (this.$refs["form"]) {
                this.$refs["form"].resetFields();
            }
        },
        saveInteboMachineapply() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    if (this.addInteboMachineApply.khs != null && this.addInteboMachineApply.khs.length > 0) {
                        this.addInteboMachineApply.applyparentid = this.addInteboMachineApply.khs[0];
                        this.addInteboMachineApply.applystoreid = this.addInteboMachineApply.khs[1];
                    }
                    this.$postw("inteboapply/saveInteboMachineapply", this.addInteboMachineApply).then(res => {
                        if (res.sucess) {
                            this.$message({
                                message: '申请成功',
                                type: 'success'
                            });
                            this.$router.push({path: '/inteboMachine'});
                            //this.addApply();
                        }
                    });
                }
            });
        },
        goodsskuChange(val) {
            console.log(val);
            if (val == 1) {
                this.addInteboMachineApply.goodsskuname = "C100";
            } else if (val == 2) {
                this.addInteboMachineApply.goodsskuname = "A100";
            } else if (val == 3) {
                this.addInteboMachineApply.goodsskuname = "A200";
            } else if (val == 4) {
                this.addInteboMachineApply.goodsskuname = "其他";
            }
        },
        getInteboStoreSturct() {
            this.$post("inteboScheduling/getInteboStoreSturct").then(res => {
                if (res.sucess) {
                    this.inteboStoreSturct = res.object;
                }
            });
        },
    },
};
</script>
<style style lang="scss" rel="stylesheet/scss">
  .myfrom .el-form-item{
    margin-bottom:5px;
  }
  .el-picker-panel .el-date-table{
    font-size:18px;
  }
</style>


// WEBPACK FOOTER //
// src/page/intebo/inteboapply/inteboMachineApply.vue